
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.434 5.512a4.721 4.721 0 10-8.23 2.86l-.512.387a.65.65 0 00-.23.737.662.662 0 00.626.454H4.6c.167 0 .333-.009.5-.027v-1.39a.902.902 0 01.899-.899h.746a.904.904 0 01.697.333l1.983-2.311c.005-.05.005-.095.01-.144zm-3.187-.774L4.72 6.874a.563.563 0 01-.83.094l-1.03-.916a.562.562 0 11.746-.84l.563.5 1.162-1.627a.562.562 0 11.915.653z","fill":"#8BC241"}}),_c('path',{attrs:{"d":"M6 8.084h.745a.449.449 0 01.45.449v3.516a.449.449 0 01-.45.45H6a.448.448 0 01-.45-.45V8.533a.449.449 0 01.45-.45zm5.652.49h-1.197l.8-2.397a.663.663 0 00.032-.207.664.664 0 00-1.169-.436L7.75 8.302a.444.444 0 00-.108.292c.002.572.003 2.484.003 3.203a.447.447 0 00.248.4l.084.042c.343.172.721.261 1.105.261h2.08a.99.99 0 00.953-.746l.49-1.961a.983.983 0 00-.953-1.219z","fill":"#8BC241"}})])
          )
        }
      }
    